export default __webpack_public_path__ + "static/media/dashboard-background.2f55c344.png";